import styled from 'styled-components';

export const ContainerMenuPrint = styled.div`
  display: flex;
  justify-content: end;
`;
